import { z } from 'zod'

import { randomThemeSlug } from '@scalar-org/random-slug'

import { nanoid, nanoidSchema, slugSchema } from '@/utility'
/** Teams can have multiple theme definitions */
export type Theme = {
  uid: string
  /** Display name of the theme */
  name: string
  /** Description of the theme */
  description: string
  /** CSS string for the theme */
  theme: string
  /** Text identifier for the theme. Used for specifying in scalar.config.ts */
  slug: string
}

export const themeSchema = z
  .object({
    uid: nanoidSchema,
    name: z.string(),
    description: z.string(),
    theme: z.string(),
    slug: slugSchema,
  })
  .meta({ id: 'theme' })

export const defaultTheme = (cssString = ''): Theme => ({
  uid: nanoid(),
  name: 'Default Theme',
  slug: randomThemeSlug(),
  description: '',
  theme: cssString,
})
